import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  public confirmModalSubject = new Subject<any>();
  public confirmModalSource$ = this.confirmModalSubject.asObservable();
  public confirmModalWorking = false;
  public confirmModalResult = "";
  public confirmInterval: any = null;

  constructor() {
    this.confirmModalSource$.subscribe((obj: any) => { 
        if(obj.action && obj.action === "close") {
          this.confirmModalResult = obj.result;
          this.confirmModalWorking = false;
        }
      });
  }

  public openConfirmModal(message: string): Promise<any> {
    console.log("before promise");
    return new Promise<any>(resolve => {
      console.log("before next");
      this.confirmModalWorking = true;
      this.confirmModalSubject.next({action: "open", message: message});
      this.confirmInterval = setInterval(() => {
        if(this.confirmModalWorking == false)
          resolve(this.confirmModalResult == "cancel" ? false : true);
      },100);
    });
  }
}
